import { HtmlSanitiserEvent } from "../../enums/HtmlSanitiserEvent";
import { globalAnchorSanitiseEventHandler } from "../anchor-transform/GlobalAnchorSanitiseEventHandler.function";
import { IHtmlStringSanitiser } from "./interfaces/IHtmlStringSanitiser";
import { HtmlStringSanitiser } from "./HtmlStringSanitiser";

export const basicHtmlStringSanitiser: IHtmlStringSanitiser = HtmlStringSanitiser.createFromExtendedDefaults({ additionalAttributes: ["target"], forbiddenTags: ["form"] });
basicHtmlStringSanitiser.on(HtmlSanitiserEvent.BeforeElement, globalAnchorSanitiseEventHandler);
